export const experienceList = [
  {
    id: "1",
    role: "Software Engineer",
    company: "Walmart, Bentonville, AR",
    time: "Sep 2024 - May 2025",
    summary:
      "Built scalable internal tools and Walmart+ features using React/React Native with 95%+ test coverage, TypeScript, and GraphQL—shipped robust iOS/Android apps and streamlined multi-environment builds.",
  },
  {
    id: "2",
    role: "Junior Web Developer",
    company: "Wipro Technologies, Bengaluru, India",
    time: "Feb 2022 - Jun 2024",
    summary:
      "Designed and developed responsive UI layouts, widgets, and dashboards using React and Highcharts; built a functional login page with full validation; collaborated with PMs, QA, and BAs to deliver user-friendly features and optimize APIs and MS SQL database performance.",
  },
  {
    id: "3",
    role: "Web Developer Intern",
    company: "Rourkela Steel Plant, India",
    time: "Jun 2021 - Jan 2022",
    summary:
      "Built responsive interfaces with React and Tailwind, integrating AI-powered features for enhanced UX. Contributed to modular component design, performance optimization, and agile team collaboration to ship scalable web solutions.",
  },
];
